/* global $ */

class Header {
  constructor(mainApp) {
    this.mainApp = mainApp;
    this.$el = $('.Header')
  }

  setNamespace(namespace) {
    this.$el.attr('data-namespace', namespace);

    let targetNamespace = '';
    if(String(namespace).indexOf('news') != -1) {
      targetNamespace = 'news';
    } else if(namespace == 'about') {
      targetNamespace = 'about';
    } else if(namespace == 'recruit') {
      targetNamespace = 'recruit';
    }

    $('.MenuListItemBtn').each((i, e) => {
      if($(e).attr('data-namespace') == targetNamespace) {
        $(e).addClass('-current');
      } else {
        $(e).removeClass('-current');
      }
    });

  }
}
export default Header;
